import './EmptyState.scss';
import { useTranslation } from 'react-i18next';

export default function EmptyState({ title, description, icon }) {
  const { t } = useTranslation();
  const resolvedTitle = title || t('common:noData');
  const resolvedDescription = description || t('common:listEmpty');
  return (
    <div className="EmptyState">
      <div className="EmptyState__icon">
        {icon || (
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round">
            <path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z"/>
            <polyline points="13 2 13 9 20 9"/>
            <line x1="9" y1="13" x2="15" y2="13"/>
            <line x1="9" y1="17" x2="15" y2="17"/>
          </svg>
        )}
      </div>
      <h3 className="EmptyState__title">{resolvedTitle}</h3>
      <p className="EmptyState__desc">{resolvedDescription}</p>
    </div>
  );
}
